import React from "react";
import {SecondaryHeaderComponent} from "./../Common/SecondaryHeaderComponent";
import {FooterComponent} from "./../Common/FooterComponent";
import {GalleryViewerComponent} from "./GalleryViewerComponent";

import "./../../css/gallery-page.css";

const CATEGORY = "Landscape";
const STOP_SCROLLING = "stop-scrolling";

export class GalleryPage extends React.Component {

    constructor(props) {
        super(props);  // this.props.match.params.name
        this.state = {
            pageClass: ""
        }

        this.handleStopScrolling = this.handleStopScrolling.bind(this);
        this.handleEnableScrolling = this.handleEnableScrolling.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0,0);
    }

    handleStopScrolling() {
        if (this.state.pageClass !== STOP_SCROLLING) {
            this.setState({ pageClass: STOP_SCROLLING });
        }
    }

    handleEnableScrolling() {
        this.setState({ pageClass: "" });
    }

    render() {
        return (
            <div id="gallery-page" className={this.state.pageClass}>
                <SecondaryHeaderComponent />
                <GalleryViewerComponent category={CATEGORY} paramName={this.props.match.params.name} stopScrolling={this.handleStopScrolling} enableScrolling={this.handleEnableScrolling} />
                <FooterComponent />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/widgets/Gallery/GalleryPage.js